export default "__VITE_ASSET__B1WQ1jC8__"